import React from 'react';
import { Link } from 'react-router-dom';
import projMan from '../../images/projSub.jpg';
import blog4 from '../../images/blog-details/comments-author/img-2.jpg';
import blog5 from '../../images/blog-details/comments-author/img-3.jpg';
import blog6 from '../../images/blog-details/author.jpg';
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';
import Secretary from '../../images/studentReq.jpg';

const DigitalMarketingSpecialist = (props) => {
    const { slug } = useParams();
    const BlogDetails = blogs.find(item => item.slug === slug);

    const submitHandler = (e) => {
        e.preventDefault();
    };

    return (
        <section className="blog-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-9 col-12 ${props.blRight}`}>
                        <div className="blog-content">
                            <div className="tag-share">
                                <div className="post format-standard-image">
                                    <div className="entry-media">
                                        <img src={Secretary} alt="" />
                                    </div>
                                    <ul className="entry-meta">
                                        <li><Link to="">FFSD GROUP</Link></li>
                                        <li><Link to="">Location: GRA, Ikeja. Lagos</Link></li>
                                        <li><Link to="">Employment Type: Full-Time</Link></li>
                                        <li><Link to="">Salary: ₦180,000 - ₦200,000</Link></li>
                                    </ul>
                                    
                                    <h2>Job Title: Student Recruitment & Admissions Officer</h2>
                                    
                                    <h3>Job Summary</h3>
                                    <p>
                                        We are seeking a proactive and results-driven Student Recruitment & Admissions Officer to support prospective students throughout their study abroad journey, from initial enquiry to enrolment. The ideal candidate will have experience in international student recruitment, admissions processing, customer relationship management, and student counselling.
                                    </p>
                                    <p>
                                        The successful candidate will be responsible for managing applications, processing offers, verifying documents, monitoring admissions progress, and providing exceptional support to applicants.
                                    </p>
                                    
                                    <h3>Key Responsibilities</h3>
                                    <p>
                                        • Review, verify, and process student applications accurately within agreed timelines, ensuring all required documents are complete and submitted to partner institutions.<br />
                                        • Monitor offer requests, liaise with partner institutions, and track application progress to ensure timely issuance of conditional and unconditional offers.<br />
                                        • Maintain accurate applicant records in the CRM and provide regular updates throughout the admissions process.<br />
                                        • Verify academic credentials, supporting documents, and financial records to ensure compliance with institutional admission requirements and visa regulations.<br />
                                        • Monitor CAS timelines, support students through Pre-CAS requirements, and provide guidance on visa-related processes and documentation.<br />
                                        • Respond promptly to student inquiries via email, phone, social media, and walk-in interactions, providing clear and accurate guidance on study options and application processes.<br />
                                        • Assess prospective students' academic profiles, career goals, and budgets to recommend suitable study pathways and ensure a seamless student experience.<br />
                                        • Actively promote partner institutions, programmes, and study opportunities through direct outreach, events, social media engagement, and referral initiatives.<br />
                                        • Collaborate with counsellors, marketing teams, and partner institutions to achieve recruitment targets, generate leads, and improve student conversion rates.
                                    </p>

                                    <h3>Requirements</h3>
                                    <p>
                                        • Bachelor's degree in Education, Business Administration, Marketing, Public Relations, or a related field.<br />
                                        • Minimum of 1–2 years' experience in a similar role within a study abroad agency, public relations, or customer support.<br />
                                        • Strong understanding of international admissions processes and student visa requirements - no prior experience is necessary but having experience in student recruitment can be an added advantage.<br />
                                        • Excellent verbal and written communication skills.<br />
                                        • Exceptional customer service and relationship management skills.<br />
                                        • Strong attention to detail and organizational abilities.<br />
                                        • Ability to manage multiple applications and deadlines simultaneously.<br />
                                        • Proficiency in Microsoft Office Suite is required.
                                    </p>

                                    <h3>Required Skills</h3>
                                    <p>
                                        • Proficiency in Microsoft Office Suite is required.<br />
                                        • Experience using admissions portals, CRM systems, and virtual communication tools.<br />
                                        • Results-oriented and highly organized.<br />
                                        • Strong interpersonal and problem-solving skills.<br />
                                        • Ability to work independently and collaboratively within a team.<br />
                                        • Professional, empathetic, and student-focused approach.<br />
                                        • Ability to thrive in a fast-paced, target-driven environment.
                                    </p>

                                    <div className="important-notice" style={{backgroundColor: '#e8f5e9', padding: '15px', borderLeft: '4px solid #2e7d32', margin: '20px 0'}}>
                                        <h4 style={{color: '#1b5e20', marginTop: '0'}}>📋 Application Details</h4>
                                        <p style={{marginBottom: '0'}}>
                                            <strong>Positions Available:</strong> 1<br />
                                            <strong>Location:</strong> GRA, Ikeja. Lagos<br />
                                            <strong>Application Deadline:</strong> 19th of June, 2026
                                        </p>
                                    </div>

                                    <h3>How to Apply</h3>
                                    <p>
                                        Interested and qualified candidates should send their CVs and Cover Letter to:<br />
                                        📧 <a href="mailto:Careers@ffsdgroup.com">Careers@ffsdgroup.com</a><br />
                                        <strong>Subject:</strong> Student Recruitment & Admissions Officer - GRA, Ikeja. Lagos
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DigitalMarketingSpecialist;